import { Spacing } from '@persona-id/design-tokens';
import { DateTime } from 'luxon';
import { BORDER_RADIUSES } from 'shared/styles/variables';
import styled from 'styled-components';

import Accordion from 'dashboard/components/Accordion';
import { AdverseMediaMediaList } from 'dashboard/components/ReportResult/AdverseMediaIdentityMatchDetails';
import { AdverseMediaIgnoreListEntry } from 'dashboard/models/report/adverse-media';
import Button from 'design-system/components/Button';
import Spacer from 'design-system/components/Spacer';
import Sticker from 'design-system/components/Sticker';
import { Paragraph } from 'design-system/components/Text';
import { headingMixins, paragraphMixins } from 'design-system/mixins/text';
import { DATE_AND_TIME_FORMAT } from 'lib/constants/luxonFormats';

const Separator = styled('span')`
  padding: 0px ${Spacing[2]};
`;

const SubTitle = styled.div`
  ${headingMixins.sm};
  font-weight: 500;
`;

const StyledList = styled.div`
  padding: ${Spacing[4]};
  margin: ${Spacing[2]} 0px;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => theme.color.border.secondary};
  border-radius: ${BORDER_RADIUSES.rounded};
`;

const SubText = styled.div`
  ${paragraphMixins.md}
  color: ${({ theme }) => theme.color.text.tertiary};
  margin: ${Spacing[2]} 0px;
`;

const Footer = styled.div`
  border-top: 1px solid ${({ theme }) => theme.color.border.secondary};
  padding-top: ${Spacing[4]};
  margin-top: ${Spacing[4]};
  margin-bottom: -${Spacing[5]};
`;

interface AdverseMediaIgnoreHistoryDetailsProps {
  entries: AdverseMediaIgnoreListEntry[];
  onBackClick: () => void;
}

export const AdverseMediaIgnoreHistoryDetails = ({
  entries,
  onBackClick,
}: AdverseMediaIgnoreHistoryDetailsProps) => {
  if (!entries) {
    return null;
  }

  return (
    <>
      {entries.map((entry: AdverseMediaIgnoreListEntry) => {
        return (
          <StyledList key={entry['match']['name']}>
            <SubTitle>Identity</SubTitle>
            <Paragraph>{entry['match']['name']}</Paragraph>
            <Spacer height={2} />
            <SubTitle>Dismissal Reason</SubTitle>
            <Paragraph>{entry['ignore-reason']}</Paragraph>
            <SubText>
              {DateTime.fromISO(entry['ignored-at']).toFormat(DATE_AND_TIME_FORMAT)}
              <Separator>•</Separator>
              {entry['user']}
            </SubText>
            <Accordion
              key={entry['match']['name']}
              menuItem={true}
              menuItemBorder={false}
              menuItemHover={false}
              caretSize='md'
              padded={false}
              defaultExpanded={false}
              titleContainerHeight='auto'
              title={
                <SubTitle>
                  Dismissed Matches <Sticker>{entry?.['match']?.['media']?.length}</Sticker>
                </SubTitle>
              }
            >
              <StyledList>
                {entry['match']['media'] && entry['match']['name'] && entry['match']['akas'] && (
                  <AdverseMediaMediaList
                    media={entry['match']['media']}
                    names={[entry['match']['name']]}
                    akas={entry['match']['akas']}
                  />
                )}
              </StyledList>
            </Accordion>
          </StyledList>
        );
      })}
      <Footer>
        <Button
          id='report-am-ignore-history-detail__back_button'
          onClick={onBackClick}
          width='auto'
          variant='basic'
        >
          Back
        </Button>
      </Footer>
    </>
  );
};
